export const DEFAULT_REDO_OVERLAY_Z_INDEX = 1_000_000;
export const MODAL_REDO_OVERLAY_Z_INDEX = 1_000_001;
export const POPPER_REDO_OVERLAY_Z_INDEX = 1_000_002;
